import * as f from "react";
import { i as h, b as p, E as d, x as v, d as m, c as x } from "../createReactComponent-58f9bea8.mjs";
import { n as o } from "../property-9daa16cd.mjs";
import { o as g } from "../if-defined-47693dfa.mjs";
import { e as y } from "../class-map-2994e95e.mjs";
var u = Object.defineProperty, b = Object.getOwnPropertyDescriptor, a = (r, i, s, n) => {
  for (var l, t = n > 1 ? void 0 : n ? b(i, s) : i, c = r.length - 1; c >= 0; c--)
    (l = r[c]) && (t = (n ? l(i, s, t) : l(t)) || t);
  return n && t && u(i, s, t), t;
}, z = ((r) => (r.DEFAULT = "default", r.EMPHASIZED = "emphasized", r))(z || {});
class e extends d {
  constructor() {
    super(...arguments), this.href = "", this.label = "", this.target = "_self", this.variant = "default", this.referrerPolicy = "";
  }
  render() {
    return v`<div
      class="${y({ container: !0, "container--variant_default": this.variant !== "emphasized", "container--variant_emphasized": this.variant === "emphasized" })}"
    >
      <a
        role="link"
        aria-label=${this.label}
        href="${this.href}"
        referrerpolicy="${g(this.referrerPolicy)}"
        target="${this.target}"
        >${this.label}</a
      >
    </div>`;
  }
}
e.styles = h`
    ${p(`:host .container{font-family:var(--exo-font-family)}:host .container.container--variant_default a{font-size:var(--exo-font-size-small);font-weight:var(--exo-font-weight-regular);line-height:24px;text-align:left;text-decoration:none;color:var(--exo-color-font-secondary)}:host .container.container--variant_emphasized a{font-size:var(--exo-font-size-micro);line-height:var(--exo-line-height-body);letter-spacing:-.01em;text-decoration:none;color:var(--exo-color-font-secondary)}:host .container a:hover,:host .container a:focus-visible{color:var(--exo-color-font-link-hover);text-decoration:underline}:host .container a:focus-visible{outline:var(--exo-spacing-3x-small) solid var(--exo-color-background-selected);border-radius:var(--exo-radius-small)}
`)}
  `, a([o()], e.prototype, "href", 2), a([o()], e.prototype, "label", 2), a([o()], e.prototype, "target", 2), a([o()], e.prototype, "variant", 2), a([o()], e.prototype, "referrerPolicy", 2);
const k = m("ex-footer-link", e), F = x({ tagName: "ex-footer-link", elementClass: e, react: f, events: {}, displayName: "ExFooterLink", registerWebComponent: k });
export {
  F as ExFooterLink,
  z as FooterLinkVariant,
  k as register
};
